module.exports = __webpack_public_path__ + "static/NotoSerif-Italic-f58bec8a41124360944f654f1bdad5a1.woff2";